import { LogoImage } from "../styled";
import { Link } from "react-router-dom";
import { useEnvContext } from "contexts/EnvProvider";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useLinks } from "hooks/useLinks";

export const FooterLogo = () => {
	const { cdnPrefix } = useEnvContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const links = useLinks();

	const handleLogoClick = () => {
		window.scrollTo(0, 0);
		reportEvent(links.home.analytics_key, { source: "tripeaks_logo_footer" });
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "logo_click",
			event_type: "tripeaks_logo_footer",
			action: links.home.analytics_key,
			source: "footer"
		});
	};

	return (
		<Link to={links.home.path} onClick={handleLogoClick}>
			<LogoImage src={`${cdnPrefix}/logo/tiki_solitaire_logo.png`} />
		</Link>
	);
};
